import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { TOOL_INFO, type Tool } from "@buildlab/shared/steps";
import "./guide.css";

// "New tool unlocked!" (Review 17, D46): the first time a student opens a lesson that unlocks a tool,
// a short arcade moment names it. One click (or Escape) closes it, and it doesn't come back.

export function ToolUnlock({ tools, onClose }: { tools: Tool[]; onClose: () => void }) {
  const button = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    button.current?.focus();
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);
  const names = tools.map((t) => TOOL_INFO[t].label);
  const title = `New tool${tools.length === 1 ? "" : "s"} unlocked!`;
  return createPortal(
    <div className="unlock-backdrop" onClick={onClose}>
      <div className="unlock" role="dialog" aria-modal="true" aria-label={`${title} ${names.join(", ")}`} onClick={(e) => e.stopPropagation()}>
        <div className="unlock-stars" aria-hidden="true" />
        <p className="unlock-kicker">{title}</p>
        <ul className="unlock-list">
          {tools.map((t) => (
            <li key={t}>
              <b>{TOOL_INFO[t].label}</b>
              <span>{TOOL_INFO[t].blurb}</span>
            </li>
          ))}
        </ul>
        <button ref={button} type="button" className="primary unlock-go" onClick={onClose}>
          Let's go!
        </button>
      </div>
    </div>,
    document.body,
  );
}
